module.exports = __webpack_public_path__ + "img/quartier.1b6c0acc.png";